import { Plus, Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

type Props = {
  query: string;
  onQueryChange: (value: string) => void;
  onNewConnection: () => void;
};

const MCPToolbar = ({ query, onQueryChange, onNewConnection }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex h-[60px] min-w-0 shrink-0 items-center justify-between gap-4 px-4 py-3">
      <h1 className="shrink-0 text-xl font-medium text-foreground">
        {t("mcpPage.title")}
      </h1>

      <div className="flex min-w-0 flex-1 items-center gap-2 sm:max-w-[406px]">
        <div className="relative min-w-0 flex-1">
          <Search
            className="pointer-events-none absolute start-3 top-1/2 size-5 -translate-y-1/2 text-muted-foreground"
            aria-hidden="true"
          />
          <Input
            type="search"
            aria-label={t("mcpPage.search")}
            placeholder={t("mcpPage.search")}
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            className="h-9 bg-input ps-10 pe-3"
          />
        </div>

        <Button
          type="button"
          onClick={onNewConnection}
          className="h-9 px-4"
        >
          <Plus className="size-4" aria-hidden="true" />
          <span className="whitespace-nowrap max-sm:sr-only">
            {t("mcpPage.newConnection")}
          </span>
        </Button>
      </div>
    </div>
  );
};

export default MCPToolbar;
